import { BehaviorSubject } from 'rxjs';
import { PAYOUTS_TO_USERS_CONFIG } from "../../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DistributionsPayoutsService {
    constructor(http) {
        this.http = http;
        this.config = PAYOUTS_TO_USERS_CONFIG;
        this.visible = new BehaviorSubject(null);
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
    getData() {
        return this.http.post(this.config.data, {});
    }
}
DistributionsPayoutsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DistributionsPayoutsService_Factory() { return new DistributionsPayoutsService(i0.ɵɵinject(i1.HttpClient)); }, token: DistributionsPayoutsService, providedIn: "root" });
